import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * Excel file SVG
 */
function FileExcelSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 24 31"
			className={classnames('roc-icon', className)}
			focusable="false"
			aria-hidden="true"
			{...rest}
		>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path
					d="M19.6874531,30.0057649 C21.2401837,30.0057649 22.4999464,28.7460023 22.4999464,27.1932717 L22.4999464,7.73435656 C22.4999464,6.99020626 22.2011418,6.2695163 21.6737993,5.74217381 L16.7577725,0.826147017 C16.2304301,0.298804524 15.5155766,0 14.7714263,0 L2.81249329,0 C1.25976262,0.0058364729 0,1.26559909 0,2.81832977 L0,27.1932717 C0,28.7460023 1.25976262,30.0057649 2.81249329,30.0057649 L19.6874531,30.0057649 Z M19.6874531,27.1932717 L2.81249329,27.1932717 L2.81249329,2.81832977 L12.1874709,2.81832977 L12.1874709,8.91206524 C12.1874709,9.69134881 12.814434,10.3183119 13.5937176,10.3183119 L19.6874531,10.3183119 L19.6874531,27.1932717 Z M19.4589151,7.50581859 L14.9999642,7.50581859 L14.9999642,3.04686774 L19.4589151,7.50581859 Z M8.9589859,24.3807784 C9.21676346,24.3807784 9.4511379,24.2401308 9.57421881,24.0116501 C10.8456544,21.6679056 10.9218718,21.3749376 11.2499732,20.6307873 C12.1230409,22.4003258 11.5956984,21.5624486 12.9257275,24.0116501 C13.0488085,24.2401308 13.2890194,24.3807784 13.5468541,24.3807784 L15.2343387,24.3807784 C15.7792478,24.3807784 16.1132428,23.7948423 15.8437351,23.3260934 L13.1249687,18.7557918 C13.1659957,18.6913617 14.9003437,15.7968144 15.8378414,14.1854902 C16.1132428,13.7167413 15.7734113,13.1308052 15.2343387,13.1308052 L13.5468541,13.1308052 C13.2890194,13.1308052 13.0546449,13.2714527 12.9316212,13.4999335 C11.8769363,15.4394163 11.6308316,15.9843254 11.2558097,16.8807962 C10.4413928,15.1757451 10.8515481,15.8671382 9.58005528,13.4999335 C9.45703159,13.2714527 9.21676346,13.1308052 8.9589859,13.1308052 L7.26560768,13.1308052 C6.72069855,13.1308052 6.38670352,13.7167413 6.65621124,14.1854902 L9.36914118,18.7557918 L6.65621124,23.3260934 C6.38086705,23.7948423 6.72069855,24.3807784 7.26560768,24.3807784 L8.9589859,24.3807784 Z"
					fill="#3F4044"
					fillRule="nonzero"
				></path>
			</g>
		</svg>
	);
}

export default FileExcelSVG;
